import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Flex } from '@interco/inter-ui/components/Flex'
import { Text, Button } from '@interco/inter-toranja'
import {
  TextSize,
  TextWeight,
  TextType,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'
import { Spacing } from '@interco/inter-ui/components/Spacing'

import { AliasErrorCode, errorContentMap, buttonLabel } from './data'

interface ErrorBottomSheetProps {
  errorCode: AliasErrorCode
  normalizedLanguage: string
  handleCloseBottomSheet: () => void
}

export const ErrorBottomSheet = ({
  errorCode,
  normalizedLanguage,
  handleCloseBottomSheet,
}: ErrorBottomSheetProps) => {
  const langContent = errorContentMap[normalizedLanguage] ?? errorContentMap['es-ES']

  const { title, description } =
    langContent[errorCode] ?? langContent[AliasErrorCode.ERROR_ON_UPDATING_ALIAS]
  const confirmLabel = buttonLabel[normalizedLanguage] ?? buttonLabel['es-ES']

  return (
    <BottomSheet onClose={handleCloseBottomSheet} noSwipe>
      <Flex direction="column" justifyContent="space-between">
        <Text textType={TextType.Title} textSize={TextSize.Medium} as="h1">
          {title}
        </Text>

        <Spacing mb="sm" />

        <Text textSize={TextSize.Large} textWeight={TextWeight.Regular} textType={TextType.Body}>
          {description}
        </Text>

        <Spacing mb="lg" />

        <Button
          hierarchy="primary"
          size="large"
          label={confirmLabel}
          onClick={() => handleCloseBottomSheet()}
          style={{ width: '100%' }}
        />
      </Flex>
    </BottomSheet>
  )
}
